// extracted by mini-css-extract-plugin
export var root = "_zj-0";
export var scroll = "_zj-1";
export var thumb = "_zj-3";
export var track = "_zj-2";